/* Page « fond de teint » (template product.fond-de-teint, 17/10/2026) : menu, galerie, offres 1 / 2 flacons,
   livraison automatique (plan d'abonnement), ajout au panier et panier latéral de la page (sections/ft-panier), pays de livraison, compte à rebours
   d'expédition, carrousels, « Lire la suite » des avis, liens vers les offres.
   Suivi CRO : les clics marqués data-cro sont lus par cro-tracker.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LG = document.documentElement.lang || 'fr';
  var ordi = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ── 26/10/2026 (tâche 8) : tiroir au style Sloown (snippets/ft-panier-s), en ligne pour toutes depuis le 26/10. ── */
  // Dates de la frise (secondes, midi heure boutique) dans la langue de la page ; points du carrousel d'avis
  function ftpMaj(b) {
    var lg = LG === 'no' ? 'nb' : LG;
    var d = function (t) { return new Date(+t * 1000); };
    $$('[data-ftp-jour]', b).forEach(function (e) {
      try { e.textContent = new Intl.DateTimeFormat(lg, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d(e.dataset.ftpJour)); }
      catch (x) { e.textContent = d(e.dataset.ftpJour).toLocaleDateString(); }
    });
    $$('[data-ftp-plage]', b).forEach(function (e) {
      var t = e.dataset.ftpPlage.split('|'), f;
      try { f = new Intl.DateTimeFormat(lg, { day: 'numeric', month: 'short', timeZone: 'UTC' }); e.textContent = f.formatRange ? f.formatRange(d(t[0]), d(t[1])) : f.format(d(t[0])) + ' – ' + f.format(d(t[1])); }
      catch (x) { e.textContent = d(t[0]).toLocaleDateString() + ' – ' + d(t[1]).toLocaleDateString(); }
    });
    var car = $('[data-ftp-car]', b), pts = $('[data-ftp-points]', b);
    if (car && pts && !car.dataset.ok) {
      car.dataset.ok = '1';
      car.addEventListener('scroll', function () {
        var c = car.children[0]; if (!c) return;
        var i = Math.round(car.scrollLeft / (c.offsetWidth + 8));
        Array.prototype.forEach.call(pts.children, function (p, k) { p.classList.toggle('on', k === i); });
      }, { passive: true });
    }
  }

  /* ── Menu mobile ── */
  (function () {
    var t = $('[data-ft-menu]'); if (!t) return;
    document.body.appendChild(t);
    $$('[data-ft-menu-ouvrir]').forEach(function (b) { b.addEventListener('click', function () { t.hidden = false; document.documentElement.style.overflow = 'hidden'; }); });
    $$('[data-ft-menu-fermer]', t).forEach(function (b) { b.addEventListener('click', function () { t.hidden = true; document.documentElement.style.overflow = ''; }); });
  })();

  /* ── Compteur du panier : suit le thème (événement « ajaxCart ») ── */
  function majCompte() {
    fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-ft-compte]').forEach(function (e) { e.textContent = c.item_count; e.hidden = !c.item_count; });
    }).catch(function () {});
  }
  window.addEventListener('ajaxCart', majCompte);

  /* ── Panier latéral de la page (sections/ft-panier) : remplace le tiroir du thème sur cette page.
     Le suivi CRO lit l'ouverture sur [data-cro-panier-lateral] (aria-hidden) : attribut retiré du tiroir du thème
     et posé ici (ft.js s'exécute avant cro-tracker.js). Minuteur : même clé et même durée que le tiroir du thème. ── */
  var panier = (function () {
    var b = $('[data-ft-panier]'); if (!b) return null;
    document.body.appendChild(b);
    var tiroir = $('.ft-panier__tiroir', b);
    $$('[data-cro-panier-lateral]').forEach(function (e) { e.removeAttribute('data-cro-panier-lateral'); });
    tiroir.setAttribute('data-cro-panier-lateral', '');
    var CLE = 'sloown-panier-expire', DUREE = 15 * 60 * 1000;
    function nb() { var i = $('[data-ft-panier-in]', b); return i ? +i.dataset.nb : 0; }
    function minuteur() {
      var fin = 0;
      try {
        fin = +localStorage.getItem(CLE) || 0;
        if (!nb()) { localStorage.removeItem(CLE); fin = 0; }
        else if (!fin) { fin = Date.now() + DUREE; localStorage.setItem(CLE, fin); }
      } catch (x) {}
      var r = fin ? Math.max(0, Math.round((fin - Date.now()) / 1000)) : 0, d2 = function (n) { return (n < 10 ? '0' : '') + n; };
      $$('[data-ft-minuteur-temps]', b).forEach(function (e) { e.textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60); });
      $$('[data-ft-minuteur]', b).forEach(function (e) { e.hidden = !r; });
    }
    setInterval(function () { if (!b.hidden) minuteur(); }, 1000);
    function ouvrir() {
      b.hidden = false; minuteur(); ftpMaj(b);
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-ouvert'); tiroir.setAttribute('aria-hidden', 'false'); }); });
    }
    function fermer() {
      b.classList.remove('is-ouvert'); tiroir.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!b.classList.contains('is-ouvert')) b.hidden = true; }, 300);
    }
    // Cadeaux (vrais produits à 0 €) : data-cad = « cadeau:l<lot> » → un par lot 2 flacons, « cadeau:a<lot> » → un par lot,
    // 1 flacon compris (cadeau surprise) ; anciennes règles « v<variante> » / « p<produit> » toujours lues ; retirés sinon
    function cadeaux() {
      var regles = (b.dataset.cad || '').split(',').filter(Boolean);
      if (!regles.length) return Promise.resolve();
      return fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var q = function (cle, id) { return c.items.reduce(function (s, it) { return s + (String(it[cle]) === String(id) ? it.quantity : 0); }, 0); };
        var maj = {}, diff = false;
        regles.forEach(function (rg) {
          var x = rg.split(':'), id = x[0], src = x[1] || '', k = src[0], n;
          // 24/10/2026 (lots en quantité, snippets/rs-lots) : « l<lot> » = un par lot (unité × taille du lot, ou ancienne ligne du lot),
          // « a<lot> » = un par lot, unité seule comprise (arrondi au-dessus).
          var m = (window.rsLots || {})[src.slice(1)];
          if ((k === 'l' || k === 'a') && m) {
            var u = q('variant_id', m[0]);
            n = q('variant_id', src.slice(1)) + (k === 'l' ? Math.floor(u / m[1]) : Math.ceil(u / m[1]));
          } else n = q(k === 'p' ? 'product_id' : 'variant_id', src.slice(1));
          if (q('variant_id', id) !== n) { maj[id] = n; diff = true; }
        });
        if (!diff) return;
        return fetch(racine + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: maj }) });
      }).catch(function () {});
    }
    // Recharge le contenu (prix et textes rendus par Shopify, dans la langue et la devise du visiteur)
    function recharger() {
      var sid = b.dataset.sid;
      return cadeaux().then(function () { return fetch(location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sec) {
        var d = document.createElement('div'); d.innerHTML = sec[sid];
        var neuf = $('[data-ft-panier-in]', d), vieux = $('[data-ft-panier-in]', b);
        if (neuf && vieux) vieux.parentNode.replaceChild(neuf, vieux);
        ftpMaj(b);
        // Le minuteur du thème (layout/theme.liquid) lit le nombre d'articles sur son tiroir, jamais rechargé ici :
        // sans cette mise à jour, il croit le panier vide et remet le délai à zéro chaque seconde.
        var c = $('#cart'), t = $('#cart [data-totalqty]');
        if (c && !t) { t = document.createElement('div'); t.hidden = true; c.appendChild(t); }
        if (t) t.setAttribute('data-totalqty', nb());
        minuteur(); majCompte();
      }); });
    }
    b.addEventListener('click', function (e) {
      if (e.target.closest('[data-ft-panier-fermer]')) { fermer(); return; }
      var pl = e.target.closest('[data-ftp-plus]');
      if (pl) { var av = pl.closest('.ftp-avis'); if (av) av.classList.toggle('is-ouvert'); return; }
      var aj = e.target.closest('[data-ft-panier-ajout]');
      if (aj) {
        $('[data-ft-panier-in]', b).classList.add('is-maj');
        fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +aj.dataset.ftPanierAjout, quantity: 1 }] }) })
          .then(recharger, recharger).catch(function () { location.href = racine + 'cart'; });
        return;
      }
      var q = e.target.closest('[data-ft-qte]'); if (!q) return;
      var l = q.closest('[data-ligne]'), v = +q.dataset.ftQte;
      var n = v === 0 ? 0 : Math.max(0, +l.dataset.q + v);
      $('[data-ft-panier-in]', b).classList.add('is-maj');
      fetch(racine + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +l.dataset.ligne, quantity: n }) })
        .then(recharger).catch(function () { location.href = racine + 'cart'; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !b.hidden) fermer(); });
    $$('[data-ft-panier-ouvrir]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); recharger().catch(function () {}); }); });
    return { ouvrir: ouvrir, recharger: recharger };
  })();

  /* ── Pop-up d'offre après l'ajout (sections/ft-upsell) : seulement si le produit proposé n'est pas déjà au panier.
     Quelle que soit la réponse, la suite (ouverture du panier latéral) est appelée ensuite. ── */
  var upsell = (function () {
    var u = $('[data-ft-upsell]'); if (!u) return null;
    document.body.appendChild(u);
    var CLE = 'ft-upsell-fin', DUREE = 15 * 60 * 1000, suite = null, tic = null, oui = $('[data-ft-upsell-oui]', u);
    function chrono() {
      var fin = 0;
      try { fin = +localStorage.getItem(CLE) || 0; if (fin <= Date.now()) { fin = Date.now() + DUREE; localStorage.setItem(CLE, fin); } } catch (x) { fin = fin || Date.now() + DUREE; }
      var r = Math.max(0, Math.round((fin - Date.now()) / 1000)), d2 = function (n) { return (n < 10 ? '0' : '') + n; };
      $('[data-ft-upsell-temps]', u).textContent = d2(Math.floor(r / 60)) + ':' + d2(r % 60);
    }
    function fermer() {
      u.hidden = true; clearInterval(tic); document.documentElement.style.overflow = '';
      var s = suite; suite = null; if (s) s();
    }
    $$('[data-ft-upsell-non]', u).forEach(function (b) { b.addEventListener('click', fermer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !u.hidden) fermer(); });
    oui.addEventListener('click', function () {
      oui.disabled = true;
      fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +u.dataset.id, quantity: 1 }] }) })
        .then(function () { oui.disabled = false; fermer(); }, function () { oui.disabled = false; fermer(); });
    });
    return {
      proposer: function (s) {
        return fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var deja = c.items.some(function (it) { return String(it.product_id) === u.dataset.produit; });
          if (deja) return s();
          suite = s; chrono(); tic = setInterval(chrono, 1000);
          u.hidden = false; document.documentElement.style.overflow = 'hidden';
        }).catch(s);
      }
    };
  })();

  /* ── Liens vers une partie de la page (note → avis, « Profiter de l'offre » → offres) ── */
  $$('[data-ft-vers]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var c = $(a.getAttribute('data-ft-vers')); if (!c) return;
      e.preventDefault();
      var h = ($('.ft-entete') || {}).offsetHeight || 0;
      window.scrollTo({ top: c.getBoundingClientRect().top + window.pageYOffset - h - 16, behavior: 'smooth' });
    });
  });

  /* ── Carrousels : flèches (une carte), points (ingrédients) ── */
  $$('[data-ft-carrousel]').forEach(function (c) {
    var piste = $('[data-ft-piste-c]', c), cartes = Array.prototype.slice.call(piste.children);
    var fl = $$('[data-ft-c]', c), pts = $('[data-ft-points]', c);
    var pas = function () { return cartes[1] ? cartes[1].offsetLeft - cartes[0].offsetLeft : piste.clientWidth; };
    var max = function () { return piste.scrollWidth - piste.clientWidth; };
    var nPages = function () { return Math.max(1, Math.round(max() / pas()) + 1); };
    function maj() {
      var x = piste.scrollLeft, m = max();
      fl.forEach(function (f) { f.disabled = +f.dataset.ftC < 0 ? x <= 2 : x >= m - 2; });
      if (pts) {
        var n = nPages(), i = Math.round(x / pas());
        if (pts.children.length !== n) { pts.textContent = ''; for (var k = 0; k < n; k++) pts.appendChild(document.createElement('i')); }
        Array.prototype.forEach.call(pts.children, function (p, k) { p.classList.toggle('is-on', k === Math.min(i, n - 1)); });
      }
    }
    fl.forEach(function (f) { f.addEventListener('click', function () { piste.scrollBy({ left: +f.dataset.ftC * pas(), behavior: 'smooth' }); }); });
    var t; piste.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(maj, 80); }, { passive: true });
    window.addEventListener('resize', maj); maj();
  });

  /* ── Avis : « Lire la suite » (seulement si le texte est coupé) ── */
  (function () {
    var T = $('[data-ft-t]') ? JSON.parse($('[data-ft-t]').textContent) : {};
    $$('[data-ft-plus]').forEach(function (b) {
      var txt = b.previousElementSibling;
      function besoin() { b.hidden = !txt.classList.contains('is-ouvert') && txt.scrollHeight <= txt.clientHeight + 2; }
      b.addEventListener('click', function () {
        var o = txt.classList.toggle('is-ouvert');
        b.textContent = o ? (T.moins || b.textContent) : (T.plus || b.textContent);
      });
      besoin(); window.addEventListener('resize', besoin);
    });
  })();

  /* ── Pied de page : menus ouverts sur ordinateur, en accordéons sur mobile ── */
  function piedOuvert() { $$('.ft-pied__col').forEach(function (d) { if (ordi()) d.open = true; }); }
  piedOuvert(); window.addEventListener('resize', piedOuvert);

  var P = $('[data-ft-produit]');
  if (!P) return;
  var T = JSON.parse($('[data-ft-t]').textContent);

  /* ── Galerie : vignettes ↔ photo affichée ── */
  (function () {
    var piste = $('[data-ft-piste]', P), vigs = $$('.ft-galerie__vig', P);
    if (!piste) return;
    function courant() { return Math.round(piste.scrollLeft / piste.clientWidth); }
    function majVig() {
      var i = courant();
      vigs.forEach(function (v, k) { v.classList.toggle('is-on', k === i); });
      if (vigs[i]) { var b = $('[data-ft-vignettes]', P); b.scrollTo({ left: vigs[i].offsetLeft - b.clientWidth / 2 + vigs[i].clientWidth / 2, behavior: 'smooth' }); }
    }
    vigs.forEach(function (v) { v.addEventListener('click', function () { piste.scrollTo({ left: +v.dataset.i * piste.clientWidth, behavior: 'smooth' }); }); });
    var t; piste.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(majVig, 90); }, { passive: true });
  })();

  /* ── Offres + livraison automatique → variante et plan envoyés au panier ── */
  var offres = $$('[data-ft-offre]', P), champId = $('[data-ft-id]', P), champPlan = $('[data-ft-plan]', P), abo = $('[data-ft-abo]', P);
  function offre() { return offres.filter(function (o) { return o.classList.contains('is-on'); })[0] || offres[0]; }
  function maj() {
    var o = offre(), a = !!(abo && abo.checked && o.dataset.plan);
    P.setAttribute('data-o', o.dataset.ftOffre);
    P.setAttribute('data-a', a ? '1' : '0');
    champId.value = o.dataset.id;
    if (champPlan) { champPlan.value = a ? o.dataset.plan : ''; champPlan.disabled = !a; }
    // Barre collante : prix affiché de l'offre choisie (avec ou sans livraison automatique) + prix barré
    var sp = $('[data-ft-sticky-px]');
    if (sp) {
      sp.textContent = '';
      var px = $('.ft-offre__prix [data-ft-a="' + (a ? 1 : 0) + '"]', o) || $('.ft-offre__prix [data-ft-a="0"]', o), barre = $('.ft-offre__prix s', o);
      if (px) sp.appendChild(px.cloneNode(true));
      if (barre) sp.appendChild(barre.cloneNode(true));
    }
  }
  offres.forEach(function (o) {
    function choisir() {
      offres.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
      maj();
    }
    o.addEventListener('click', choisir);
    o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choisir(); } });
  });
  if (abo) abo.addEventListener('change', maj);
  maj();

  /* ── Ajout au panier : vrai formulaire /cart/add (suivi CRO), envoyé en AJAX puis panier latéral de la page ── */
  var form = $('[data-ft-form]', P), bouton = $('[data-ft-ajout]', P), err = $('[data-ft-erreur]', P);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (offre().dataset.dispo !== 'true') { err.textContent = T.indispo; err.hidden = false; return; }
    err.hidden = true; bouton.disabled = true;
    fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        bouton.disabled = false;
        if (!panier) { location.href = racine + 'cart'; return; }
        var suite = function () { return panier.recharger().then(panier.ouvrir).catch(function () { location.href = racine + 'cart'; }); };
        return upsell ? upsell.proposer(suite) : suite();
      })
      .catch(function (d) { bouton.disabled = false; err.textContent = (d && (d.description || d.message)) || T.erreur; err.hidden = false; });
  });
  // 01/11/2026 (cro-pages, tâche #229) : utilisé seulement par sections/ft-direct (fiche du quiz « paiement direct ») ; inerte ailleurs.
  window.ftApi = { panier: panier, upsell: upsell, form: form, offres: offres };

  /* ── Barre d'achat collante : affichée quand le bouton « Ajouter au panier » est sorti de l'écran par le haut ── */
  (function () {
    // « Acheter » remonte aux offres par le lien data-ft-vers (branché plus haut).
    var st = $('[data-ft-sticky]'); if (!st || !window.IntersectionObserver) return;
    document.body.appendChild(st);
    new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('ft-sticky-on', on);
    }).observe(bouton);
  })();

  /* ── Pays de livraison : pays réel du visiteur (en-tête Server-Timing « country », comme snippets/rs-auto ;
     sur le marché international, Shopify met tout le monde aux États-Unis), sinon celui de Shopify ── */
  (function () {
    var e = $('[data-ft-pays]', P); if (!e) return;
    var code = null;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      ((nav && nav.serverTiming) || []).forEach(function (s) { if (s.name === 'country') code = s.description; });
      if (!code) code = sessionStorage.getItem('rs_pays');
    } catch (x) {}
    if (!code || !/^[A-Z]{2}$/.test(code) || code === e.dataset.code) return;
    var nom = code;
    try { nom = new Intl.DisplayNames([LG], { type: 'region' }).of(code); } catch (x) {}
    $('[data-ft-drapeau]', e).src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=32';
    $('[data-ft-pays-txt]', e).innerHTML = e.dataset.modele.replace('[p]', nom.replace(/[<>&]/g, ''));
  })();

  /* ── Compte à rebours du bloc « Ça part vite » : temps restant avant minuit (heure locale), repart chaque jour. ── */
  (function () {
    var c = $('[data-ft-compte-rebours]', P); if (!c) return;
    var d2 = function (n) { return (n < 10 ? '0' : '') + n; };
    function tic() {
      var m = new Date(), fin = new Date(m.getFullYear(), m.getMonth(), m.getDate() + 1), r = Math.max(0, fin - m);
      c.textContent = d2(Math.floor(r / 3600000)) + ':' + d2(Math.floor(r / 60000) % 60) + ':' + d2(Math.floor(r / 1000) % 60);
    }
    tic(); setInterval(tic, 1000);
  })();
})();
